export const  CONSTANTS = {
    httpErrorCodes: {
        status502: 'Sorry, service temporarily unavailable, please try again later.',
        status500: 'Sorry, there was an internal server error. We already working to fix it.',
        status404: 'Sorry, the resource you requested cannot be found.',
        status403: 'Sorry, you are not allowed to perform this operation.'
    },

    cacheKeys: {
        token: 'apiToken',
    },

    tacticPositions: {
        gk: 1,
        sw: 2,
        df: 3,
        dm: 4,
        mf: 5,
        am: 6,
        fw: 7,
    },

    tacticPositionNames: {
        gk: "GK",
        sw: "SW",
        df: "DF",
        dm: "DM",
        mf: "MF",
        am: "AM",
        fw: "FW",
    },

    tacticSides: {
        l: 1,
        lc: 2,
        c: 3,
        rc: 4,
        r: 5
    },

    pitchPositions: {
        gk:1,
        sw: 2,
        ldf: 3,
        cdf: 4,
        rdf: 5,
        ldm: 6,
        cdm: 7,
        rdm: 8,
        lmf: 9,
        cmf: 10,
        rmf: 11,
        lam: 12,
        cam: 13,
        ram: 14,
        lfw: 15,
        cfw: 16,
        rfw: 17
    },

    pitchPositionNames: {
        gk: "GK",
        sw: "SW",
        ldf: "LDF",
        cdf: "CDF",
        rdf: "RDF",
        ldm: "LDM",
        cdm: "CDM",
        rdm: "RDM",
        lmf: "LMF",
        cmf: "CMF",
        rmf: "RMF",
        lam: "LAM",
        cam: "CAM",
        ram: "RAM",
        lfw: "LFW",
        cfw: "CFW",
        rfw: "RWF"
    },

    substitutionConditions: {
        less: 1,
        equal: 2,
        more: 3
    },

    substitutionConditionNames: {
        less: "<",
        equal: "=",
        more: ">"
    },

    standardRoles: {
        captains: 1,
        cornerKickers: 2,
        freeKickers: 3,
        penaltiers: 4
    },
    substitutionsMaxCount: 7,

    playerSettings: {
        passTypes: {
            team: 4,
            short: 1,
            middle: 2,
            long: 3,
        },

        passLabels: {
            team: "Командная установка",
            short: "Короткий",
            middle: "Средний",
            long: "Длинный"
        },

        variant3: {
            rare: 1,
            sometimes: 2,
            often: 3
        },

        variant2: {
            yes: 2,
            no: 1,
        },

        variant3Labels: {
            rare: "Редко",
            sometimes: "Иногда",
            often: "Часто"
        },

        variant2Labels: {
            yes: "Да",
            no: "Нет",
        },
    },

    playerSideNames: {
        L: "L",
        C: "C",
        R: "R",
    },

    playerSides: {
        L: 1,
        C: 2,
        R: 3,
    },

    playerPositionNames : {
        GK: "GK",
        SW: "SW",
        DF: "DF",
        DM: "DM",
        MF: "MF",
        AM: "AM",
        FW: "FW"
    },
    playerMoveDirections: {
        left: 1,
        right: 2,
        up: 3,
        down: 4,
    },
    weatherIds: {
        sunny: 0,
        rain: 1,
    },
    weatherNames: {
        sunny: "Солнечно",
        rain: "Дождь",
    },

    userRoles: {
        admin: 1,
        schoolInspector: 2
    },

    routes: {
        admin: {
            dashboard: "admin/dashboard",
            users: "admin/users",
            matchDays: "admin/match-days",
            euroCup: "admin/drawings/euro",
            secondTour16: "admin/drawings/second-tour-16",
            secondTour12: "admin/drawings/second-tour-12",
            drawindNationalCups: "admin/drawings/national-cups",
            drawingNationalSuperCups: "admin/drawings/national-super-cups",
            drawingWCFinal: "admin/drawings/wc-final",
            drawingWCPlayoff: "admin/drawings/wc-playoff",
            drawingWCQual: "admin/drawings/qualification",
            drawingEuroSuperCup: "admin/drawings/euro-super-cup",
            drawingClubWCGroup: "admin/drawings/club-wc-group",
            drawingClubWCPlayoff: "admin/drawings/club-wc-playoff",
            jobLogs: "admin/job-logs",
            maintenance: "admin/maintenance",
            drawingCarousel: "admin/drawings/carousel",
            
        }
    },

    euroCupStages: {
        qual1: 1,
        qual2: 2,
        group: 3,
        playoff64: 4,
        playoff32: 5,
        playoff16: 6,
        playoff8: 7,
        playoff4: 8,
        playoff2: 9,
        final: 10,
    },

    euroCupStagesNames: {
        qual1: "Кв1.",
        qual2: "Кв2.",
        group: "Груп.",
        playoff64: "1/64",
        playoff32: "1/32",
        playoff16: "1/16",
        playoff8: "1/8",
        playoff4: "1/4",
        playoff2: "1/2",
        final: "Финал",
    },

    euroCups: {
        chamionsLeague: 0,
        europeLeague: 1,
        conferenceLeague: 2,
    },

    sortDirection: {
        asc: 1,
        desc: 2,
    },

    rosterSortFields: {
        name: 1,
        position: 2,
        age: 3,
        phys: 4,
        morale: 5,
        power: 6,
        cost: 7,
        wage: 8,
        contractLength: 9,
        skillStamina: 10,
        skillForce: 11,
        skillSpeed: 12,
        skillLead: 13,
        skillDribbling: 14,
        skillTechnique: 15,
        skillPowerShot: 16,
        skillAccuracyShot: 17,
        skillFreeKick: 18,
        skillCornerKick: 19,
        skillVision: 20,
        skillPositioning: 21,
        skillHead: 22,
        skillTackling: 23,
        skillCross: 24,
        skillPass: 25,
    },
    rosterColumnTypes: {
        general: 1,
        contract: 2,
        skills: 3,
    },
    banTypes: {
        national: 1,
        euroCup: 3,
        wc: 5
    },
    maintenanceJobs: {
        clearTransfers: 1,
        clearRentList: 2,
        clearTransferList: 3,
        midSeasonForm: 4,
        backRent: 5,
        backRentLogHalfSeason: 6,
    },
    playerFilterTypes: {
        position: 1,
        side: 2,
    }
}